export default __webpack_public_path__ + "static/media/022-first-aid-kit.7a80f316.png";